import { createDeepEqualSelector } from '../../../../../helpers/memoizeHelper';
import { IApplicationState, TBoardId } from '../../../../../../../types/types';
import { ISearchSelectOption } from '../../../../../base/components/SearchSelect/types';
import { TStatus } from '../../../../../../../types/model';
import { getBoardCards } from '../../../../../../../store/model/selectors/getBoardCards';
import { getCardIsEpic } from '../../../../../../../store/model/selectors/getCardIsEpic';
import { getCardListName } from '../../../../../../../store/model/selectors/getCardListName';
import { getCardFullNameHelper } from '../../../../../../../store/model/card/helpers/getCardFullNameHelper';
import { getCardIcon } from '../../../../../helpers/getCardIcon';
import { stripHtml } from '../../../../../base/helpers/stripHtmlHelper';
import { getAppState } from '../../../../../../../store/configureStore';
import { markdown } from '../../../../../../../helper/markdownHelper';
import { ICard } from 'app/store/model/card/types';
import {
    getBoardUserRecentCards
} from '../../../../../../../store/model/board/selectors/getBoardUserRecentCards';
import { MAX_RECENT_CARDS } from '../../../../../../../const';

type TgetSearchSelectRecentCardOptions = (
    state: IApplicationState,
    boardId: TBoardId,
    status: TStatus
) => ISearchSelectOption[];

export const getSearchSelectRecentCardOptions: TgetSearchSelectRecentCardOptions = createDeepEqualSelector(
    getBoardCards,
    (state: IApplicationState, boardId: TBoardId) => getBoardUserRecentCards(boardId),
    (cards: ICard[], recentCardIds) => {
        const options: ISearchSelectOption[]  = recentCardIds
            .reduce((recentCards, cardId) => {
                const card = cards.find(card => card.id === cardId);
                if (card) {
                    const isEpic = getCardIsEpic(getAppState(), card.id);
                    const listName = getCardListName(getAppState(), card.id);
                    const cardFullName = getCardFullNameHelper(card);
                    recentCards.push({
                        img: getCardIcon(card.status, isEpic),
                        text: stripHtml(markdown(cardFullName)),
                        textSub: stripHtml(markdown(listName)),
                        value: String(card.id),
                    });
                }
                return recentCards;
            }, [])
            .slice(0, MAX_RECENT_CARDS);
        return options;
    }
)
